const TermsAndConditions = () => {
  return (
    <div className="mx-auto p-6 sm:p-8 bg-white shadow-lg rounded-lg">
      <h1 className="text-3xl sm:text-4xl font-extrabold text-gray-900 mb-6 text-center">
        Terms of Service
      </h1>

      <h2 className="text-2xl font-semibold text-gray-800 mt-6 mb-4">
        1. Introduction
      </h2>
      <p className="text-gray-700 leading-relaxed mb-6">
        Welcome to <strong>Sunday School</strong>. By accessing or using our website,
        platform, or services, you agree to comply with these Terms of Service. These
        terms govern your use as a contributor, teacher, parent, or learner.
      </p>

      <h2 className="text-2xl font-semibold text-gray-800 mt-6 mb-4">
        2. User Accounts
      </h2>
      <p className="text-gray-700 mb-4">
        To access certain features, you may need to create an account. You are
        responsible for maintaining the confidentiality of your login information
        and for all activities that occur under your account.
      </p>
      <p className="text-gray-700 mb-4">
        Users must provide accurate information when creating an account. Sunday
        School reserves the right to suspend or terminate accounts for any
        violation of these terms.
      </p>

      <h2 className="text-2xl font-semibold text-gray-800 mt-6 mb-4">
        3. Roles and Responsibilities
      </h2>
      <p className="text-gray-700 mb-4">
        Our platform offers different roles with specific permissions:
      </p>
      <ul className="list-disc list-inside text-gray-700 space-y-2 mb-6">
        <li>
          <strong>Contributors:</strong> Share lessons, devotionals, and other
          Bible-based content. You are responsible for the accuracy and
          appropriateness of your submissions.
        </li>
        <li>
          <strong>Teachers:</strong> Create classes, manage lessons, and invite
          learners. Ensure content is safe and suitable for the targeted age
          group.
        </li>
        <li>
          <strong>Parents:</strong> Monitor child's progress responsibly. Do
          not share your account with others or access learner content not related
          to your child.
        </li>
        <li>
          <strong>Learners:</strong> Engage with lessons, quizzes, and exercises
          as intended. Do not attempt to bypass restrictions or manipulate content.
        </li>
      </ul>

      <h2 className="text-2xl font-semibold text-gray-800 mt-6 mb-4">
        4. Content Ownership and Usage
      </h2>
      <p className="text-gray-700 mb-4">
        All original content created by contributors or teachers remains their
        intellectual property. By submitting content to Sunday School, you grant
        us a non-exclusive, royalty-free license to display and use it within the
        platform for educational purposes.
      </p>
      <p className="text-gray-700 mb-4">
        Users must not copy, distribute, or misuse content from the platform
        without proper permission.
      </p>

      <h2 className="text-2xl font-semibold text-gray-800 mt-6 mb-4">
        5. Privacy and Children’s Safety
      </h2>
      <p className="text-gray-700 mb-4">
        Sunday School takes privacy seriously. Personal information is collected
        only for account management, progress tracking, and program communication.
      </p>

      <h2 className="text-2xl font-semibold text-gray-800 mt-6 mb-4">
        6. Acceptable Use
      </h2>
      <p className="text-gray-700 mb-4">
        Users agree to:
      </p>
      <ul className="list-disc list-inside text-gray-700 space-y-2 mb-6">
        <li>Use the platform for educational and faith-based purposes only.</li>
        <li>Respect other users and not post harmful, offensive, or inappropriate content.</li>
        <li>Not attempt to hack, disrupt, or interfere with the platform’s functionality.</li>
      </ul>

      <h2 className="text-2xl font-semibold text-gray-800 mt-6 mb-4">
        7. Termination
      </h2>
      <p className="text-gray-700 mb-4">
        Sunday School reserves the right to suspend or terminate accounts for violations
        of these terms or inappropriate behavior. Terminated users may not attempt
        to create a new account without permission.
      </p>

      <h2 className="text-2xl font-semibold text-gray-800 mt-6 mb-4">
        8. Limitation of Liability
      </h2>
      <p className="text-gray-700 mb-4">
        Sunday School provides the platform “as is.” We are not liable for any
        direct or indirect damages arising from your use of the service, including
        lost data or progress. Use of the platform is at your own risk.
      </p>

      <h2 className="text-2xl font-semibold text-gray-800 mt-6 mb-4">
        9. Changes to Terms
      </h2>
      <p className="text-gray-700 mb-6">
        We may update these Terms of Service periodically. Changes will be posted
        on this page, and continued use of the platform after updates indicates
        acceptance of the new terms.
      </p>

      <h2 className="text-2xl font-semibold text-gray-800 mt-6 mb-4">
        10. Contact Us
      </h2>
      <p className="text-gray-700 mb-6">
        If you have questions about these Terms of Service, please contact us:
      </p>
      <ul className="list-disc list-inside text-gray-700 space-y-2">
        <li><strong>Website:</strong> sundayschools.net</li>
      </ul>
    </div>
  );
};

export default TermsAndConditions;